import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { provideNzNativeDateAdapter } from 'ng-zorro-antd/core/time';
import { NzModalService } from 'ng-zorro-antd/modal';
import {
  API_BASE_URL,
  authInterceptor,
  errorInterceptor,
  PORTAL_NAME,
  refreshTokenInterceptor,
} from '@dlap-ui/core';
import { environment } from '../environments/environment';
import {
  ArrowLeftOutline,
  ArrowRightOutline,
  AppstoreOutline,
  BankOutline,
  BranchesOutline,
  CalendarOutline,
  CheckCircleOutline,
  ClockCircleOutline,
  CloseCircleOutline,
  CustomerServiceOutline,
  DashboardOutline,
  DeleteOutline,
  DollarOutline,
  DownloadOutline,
  DownOutline,
  SettingOutline,
  EditOutline,
  EnvironmentOutline,
  ExclamationCircleOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FacebookOutline,
  FileProtectOutline,
  FileSearchOutline,
  FileExclamationOutline,
  SwapOutline,
  SplitCellsOutline,
  FileTextOutline,
  FilterOutline,
  GoldOutline,
  HistoryOutline,
  HomeOutline,
  IdcardOutline,
  InboxOutline,
  InfoCircleOutline,
  KeyOutline,
  LinkedinOutline,
  LockOutline,
  LoginOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  PhoneOutline,
  PlayCircleOutline,
  PlusOutline,
  FormOutline,
  RightOutline,
  SafetyOutline,
  SearchOutline,
  SecurityScanOutline,
  StopOutline,
  SyncOutline,
  TeamOutline,
  ThunderboltOutline,
  TwitterOutline,
  UndoOutline,
  UnorderedListOutline,
  UpOutline,
  UserOutline,
  WalletOutline,
  FileSyncOutline,
} from '@ant-design/icons-angular/icons';
import { appRoutes } from './app.routes';
import { operationsDashboardMockInterceptor } from './services/operations-dashboard.mock';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([operationsDashboardMockInterceptor, authInterceptor, errorInterceptor, refreshTokenInterceptor])),
    provideRouter(appRoutes),
    provideNzI18n(en_US),
    provideNzNativeDateAdapter(),
    NzModalService,
    { provide: API_BASE_URL, useValue: environment.server },
    { provide: PORTAL_NAME, useValue: 'DEEDS' },
    provideNzIcons([
      MailOutline,
      LockOutline,
      KeyOutline,
      EyeOutline,
      EyeInvisibleOutline,
      MenuFoldOutline,
      MenuUnfoldOutline,
      SearchOutline,
      PlusOutline,
      UserOutline,
      DownOutline,
      LogoutOutline,
      AppstoreOutline,
      FilterOutline,
      CalendarOutline,
      UndoOutline,
      EditOutline,
      DeleteOutline,
      SplitCellsOutline,
      FormOutline,
      CloseCircleOutline,
      CheckCircleOutline,
      DollarOutline,
      DownloadOutline,
      TeamOutline,
      WalletOutline,
      HomeOutline,
      SwapOutline,
      BankOutline,
      BranchesOutline,
      EnvironmentOutline,
      IdcardOutline,
      FileProtectOutline,
      FileSearchOutline,
      FileSyncOutline,
      FileExclamationOutline,
      FileTextOutline,
      InboxOutline,
      GoldOutline,
      ExclamationCircleOutline,
      HistoryOutline,
      SecurityScanOutline,
      UnorderedListOutline,
      DownloadOutline,
      DashboardOutline,
      PlayCircleOutline,
      StopOutline,
      ArrowLeftOutline,
      ArrowRightOutline,
      RightOutline,
      ClockCircleOutline,
      SettingOutline,
      CustomerServiceOutline,
      FacebookOutline,
      InfoCircleOutline,
      LinkedinOutline,
      LoginOutline,
      PhoneOutline,
      SafetyOutline,
      SyncOutline,
      ThunderboltOutline,
      TwitterOutline,
      UpOutline,
    ]),
  ],
};
